// extracted by mini-css-extract-plugin
export default {"root":"booking_not_permitted_message-module___root___cfc8de94"};